import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import styled from 'styled-components';
import React, { useState, useCallback } from 'react';
import { memoNamed } from '../utils/react/memo-named';
import { Check } from '../types/user';

interface Props {
  tagKey: string;
  tagName: string;
  privateIsDisabled: boolean;
  inputValue: string;
  isPublic: boolean;
  docID: string;
  check: (input: string) => Check;
}

const EditInfoWrapper = styled.div`
  width: 100%;
  margin: 0 auto;
  font-size: 11px;
  background-color: #d3cbc6;
`;

const EditInfoUpper = styled.div`
  background-color: #d3cbc6;
  text-align: left;
`;

const EditInfoInputWrapper = styled.div`
  width: 100%;
  background-color: #d3cbc6;
  margin: 0 auto;
`;

const EditInfoInput = styled.input`
  width: 100%;
  outline: none;
  border: none;
  font-size: 15px;
  background-color: #d3cbc6;
  &:focus {
    outline: none;
  }
`;

const Message = styled.div`
  color: red;
  background-color: #d3cbc6;
  text-align: left;
`;

export const NamesEditInfo = memoNamed<Props>('NamesEditInfo', (props) => {
  const [editInfoInputValuePrevious, setEditInfoInputValuePrevious] = useState<
    string
  >(props.inputValue);
  const [editInfoInputValue, setEditInfoInputValue] = useState<string>(
    props.inputValue
  );
  const [isPublic, setIsPublic] = useState<boolean>(props.isPublic);
  const [isUpdating, setIsUpdating] = useState<boolean>(false);
  const [message, setMessage] = useState<string>('');
  const [isCorrect, setIsCorrect] = useState<boolean>(false);

  const onEditInfoInputValueChange = useCallback(() => {
    // if unchanged
    if (editInfoInputValuePrevious === editInfoInputValue) return;
    // if not correct
    if (!isCorrect) return;
    const db = firebase.firestore();
    setIsUpdating(true);
    const id = props.docID;
    const userInfo = props.privateIsDisabled
      ? { [props.tagKey]: editInfoInputValue }
      : {
          [`${props.tagKey}.value`]: editInfoInputValue,
        };
    db.collection('Users')
      .doc(id)
      .update(userInfo)
      .then(() => {
        setEditInfoInputValuePrevious(editInfoInputValue);
        setIsUpdating(false);
        setMessage('');
      })
      .catch(() => {
        setIsUpdating(false);
        setMessage('データ保存時にエラーが発生しました。');
      });
  }, [props, editInfoInputValuePrevious, editInfoInputValue, isCorrect]);

  const onIsPublicChange = useCallback(
    (event: React.ChangeEvent<HTMLSelectElement>) => {
      const _isPublic = event.target.value === 'public';
      setIsPublic(_isPublic);
      const db = firebase.firestore();
      setIsUpdating(true);
      const id = props.docID;
      db.collection('Users')
        .doc(id)
        .update({
          [`${props.tagKey}.open`]: _isPublic,
        })
        .then(() => {
          setIsUpdating(false);
          setMessage('');
        })
        .catch(() => {
          setIsUpdating(false);
          setMessage('データ保存時にエラーが発生しました。');
        });
    },
    [props.tagKey, props.docID]
  );

  const onEditInfoInputValueCheck = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setEditInfoInputValue(event.target.value);
      const checkResult: Check = props.check(event.target.value);
      setMessage(checkResult.alert);
      setIsCorrect(checkResult.isCorrect);
    },
    [props]
  );

  return (
    <div>
      <EditInfoWrapper>
        <EditInfoUpper>
          {props.tagName}
          {props.privateIsDisabled ? undefined : (
            <select
              id={`${props.tagKey}_open`}
              value={isPublic ? 'public' : 'private'}
              onChange={onIsPublicChange}
            >
              <option value='public'>名簿に記載</option>
              <option value='private'>非公開</option>
            </select>
          )}
          {isUpdating ? '  通信中...' : undefined}
        </EditInfoUpper>
        <Message>{message}</Message>
        <EditInfoInputWrapper>
          <EditInfoInput
            id={props.tagKey}
            type='text'
            value={editInfoInputValue}
            onChange={onEditInfoInputValueCheck}
            onBlur={onEditInfoInputValueChange}
          />
        </EditInfoInputWrapper>
      </EditInfoWrapper>
      <hr />
    </div>
  );
});
